<template>
  <el-form :inline="true" :model="queryParam" class="mainSearch">
    <el-form-item label="客户名称">
      <el-input v-model="queryParam.name" placeholder="输入客户名称" />
    </el-form-item>
    <el-form-item label="收款账户">
      <el-input v-model="queryParam.paidaccount" placeholder="输入收款账户" />
    </el-form-item>
    <!-- <el-form-item label="结算方式">
      <el-select v-model="queryParam.balanceway" placeholder="选择结算方式">
        <el-option label="日结" :value="1" />
        <el-option label="周结" :value="2" />
        <el-option label="半个月结" :value="3" />
        <el-option label="月结" :value="4" />
        <el-option label="季结" :value="5" />
        <el-option label="半年结" :value="6" />
        <el-option label="年结" :value="7" />
      </el-select>
    </el-form-item> -->
    <el-form-item label="有无合同">
      <el-select v-model="queryParam.iscontract" placeholder="选择有无合同">
        <el-option label="有" :value="1" />
        <el-option label="无" :value="2" />
      </el-select>
    </el-form-item>
    <el-form-item label="账期">
      <el-select v-model="queryParam.isaccount" placeholder="选择账期">
        <el-option label="日" :value="1" />
        <el-option label="周" :value="2" />
        <el-option label="月" :value="3" />
        <el-option label="半月" :value="4" />
        <el-option label="年结" :value="5" />
      </el-select>
    </el-form-item>
    <el-form-item label="客户类型">
        <el-select v-model="queryParam.customertype" placeholder="选择客户类型">
            <el-option label="积分客户" :value="1" />
            <el-option label="电商客户" :value="2" />
            <el-option label="其他客户" :value="3" />
            <el-option label="企业福利" :value="4" />
            <el-option label="产品分销" :value="5" />
          </el-select>
    </el-form-item>
    <!-- <el-form-item label="开票税点">
      <el-input v-model="queryParam.taxpoint" placeholder="输入开票税点" />
    </el-form-item> -->
    <el-form-item label="状态">
      <el-select v-model="queryParam.status" placeholder="客户状态">
        <el-option label="正常" :value="1" />
        <el-option label="停用" :value="2" />
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-button type="danger" @click="getListCustomer">查询</el-button>
      <el-button @click="resetSearch">重置</el-button>
    </el-form-item>
  </el-form>
  <el-row>
    <el-col :span="24">
      <div class="mainTableTop">
        <el-button
          type="danger"
          @click="(dialog = true), doCustomerAdd()"
          v-hasPermission="['customer:add']"
          >添加客户</el-button
        >
      </div>
    </el-col>
  </el-row>

  <el-row class="mainTableBox">
    <el-col :span="24" class="mpadding">
      <el-table :data="tableData" v-loading="loadingData" class="mainTable" row-key="customerid" height="600">
        <el-table-column label="客户ID" prop="customerid" width="200" />
        <el-table-column label="客户" prop="name" width="250" />
        <el-table-column label="账期" prop="isaccount">
          <!-- :type="scope.row.isaccount === 1 ? 'success' : 'danger'" -->
          <template #default="scope">
            <el-tag
              v-if="scope.row.isaccount"
              round
              disable-transitions
              ><span v-text="util.supplierAccount(scope.row.isaccount)"></span>
            </el-tag>
          </template>
        </el-table-column>
        <!-- <el-table-column label="结算方式" prop="balanceway">
          <template #default="scope">
            <el-tag
              round
              :type="scope.row.balanceway === 1 ? 'success' : 'danger'"
              disable-transitions
              ><span v-text="util.showBalanceway(scope.row.balanceway)"></span>
            </el-tag>
          </template>
        </el-table-column> -->
        <el-table-column label="收款账户" prop="paidaccount" width="250" />
        <el-table-column label="毛利率" prop="maoliv" width="100">
          <template #default="scope">
            <span>{{ scope.row.maoliv }}</span> ~
            <span>{{ scope.row.maolivge }}</span>
          </template>
        </el-table-column>
        <el-table-column label="有无合同" prop="iscontract">
          <template #default="scope">
            <el-tag
              round
              :type="scope.row.iscontract === 1 ? 'success' : 'danger'"
              disable-transitions
              ><span v-text="util.showYesNo(scope.row.iscontract)"></span>
            </el-tag>
          </template>
        </el-table-column>
        
        <el-table-column label="开票税点" prop="taxpoint" />
        <!-- <el-table-column label="日期" prop="created">
        <template #default="scope">
          <span
            v-text="util.formatDateUnix(scope.row.created, 'yyyy-MM-dd hh:mm')"
          ></span>
        </template>
      </el-table-column> -->
        <el-table-column label="状态" prop="status">
          
          <template #default="scope">
            <el-tag
              round
              :type="scope.row.status === 1 ? 'success' : 'danger'"
              disable-transitions
              ><span v-text="util.showCommonStatus(scope.row.status)"></span>
            </el-tag>
            <el-switch
              :model-value="scope.row.status"
              v-hasPermission="['customer:edit']"
              :active-value="1"
              :inactive-value="2"
              size="small"
              @change="doCustomerStatus(scope.$index, scope.row, 'status')"
            />
          </template>
          <!-- <template #default="scope">
          <el-tag
            round
            :type="scope.row.status === 1 ? 'success' : 'danger'"
            disable-transitions
            ><span v-text="util.showCommonStatus(scope.row.status)"></span>
          </el-tag>
        </template> -->
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="150">
          <template #default="scope">
            <el-link
              type="primary"
              size="small"
              @click="(dialog = true), doCustomerEdit(scope.$index, scope.row)"
              v-hasPermission="['customer:edit']"
              >编辑</el-link
            >

            <!-- <el-link
              type="primary"
              size="small"
              @click="open('customer:view', scope.row)"
              v-hasPermission="['customer:view']"
              >查看</el-link
            > -->
            <el-popconfirm
              confirm-button-type="danger"
              confirm-button-text="确定"
              cancel-button-text="取消"
              icon-color="#626AEF"
              title="您确定要删除吗？"
              width="200px"
              @confirm="doCustomerDelete(scope.$index, scope.row)"
            >
              <template #reference>
                <el-link
                 v-hasRole="['admin']"
                  size="small"
                  type="danger"
                  >删除</el-link
                >
              </template>
            </el-popconfirm>
            
          </template>
        </el-table-column>
      </el-table>
    </el-col>
  </el-row>

  <el-row class="mainTableBottom">
    <el-col :span="8"
      ><div>
        <!-- <el-button
            type="danger"
            >添加用户</el-button> -->
      </div></el-col
    >
    <el-col :span="16">
      <div style="float: right">
        <el-pagination
          v-model:page-size="queryParam.pageSize"
          :page-sizes="[20, 50, 100, 300, 600, 1000, 2000]"
          :background="true"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="changeChangeSize"
          @current-change="changePage"
          :current-page="queryParam.pageNo"
        />
      </div>
    </el-col>
  </el-row>

  <el-drawer
    ref="drawerRef"
    v-model="dialog"
    :close-on-click-modal="false"
    :title="title"
    direction="rtl"
    size="45%"
    @close="doCustomerClose"
  >
    <div class="common-drawer__content">
      <el-form
        ref="customerFormRef"
        :model="customerForm"
        :rules="rules"
        label-width="120px"
        autocomplete="off"
      >
      <el-form-item label="客户类型" prop="customertype">
          <el-select
            v-model="customerForm.customertype"
            placeholder="选择客户类型"
            style="width: 100%"
          >
            <el-option label="积分客户" :value="1" />
            <el-option label="电商客户" :value="2" />
            <el-option label="其他客户" :value="3" />
            <el-option label="企业福利" :value="4" />
            <el-option label="产品分销" :value="5" />
          </el-select>
        </el-form-item>
        <el-form-item label="客户名称" prop="name">
          <el-input
            v-model.trim="customerForm.name"
            placeholder="请输入客户名称"
          />
        </el-form-item>
        <!-- <el-form-item label="结算方式" prop="balanceway">
          <el-select
            v-model="customerForm.balanceway"
            placeholder="选择结算方式"
            style="width: 100%"
          >
            <el-option label="日结" :value="1" />
            <el-option label="周结" :value="2" />
            <el-option label="半个月结" :value="3" />
            <el-option label="月结" :value="4" />
            <el-option label="季结" :value="5" />
            <el-option label="半年结" :value="6" />
            <el-option label="年结" :value="7" />
          </el-select>
        </el-form-item> -->

        <el-form-item label="收款方式" prop="paidway">
          <el-select
            v-model="customerForm.paidway"
            placeholder="选择收款方式"
            style="width: 100%"
          >
            <el-option label="对公收款" :value="1" />
            <el-option label="对私收款" :value="2" />
          </el-select>
        </el-form-item>

        <el-form-item label="收款账户" prop="paidaccount">
          <el-input
            v-model.trim="customerForm.paidaccount"
            placeholder="请输入收款账户"
          />
        </el-form-item>
        <el-form-item label="毛利率区间" required>
          <el-col :span="11">
            <el-form-item prop="maoliv">
              <el-input v-model="customerForm.maoliv" placeholder="最小值" />
            </el-form-item>
          </el-col>
          <el-col :span="2" style="text-align: center">
            <span>-</span>
          </el-col>
          <el-col :span="11">
            <el-form-item prop="maolivge">
              <el-input v-model="customerForm.maolivge" placeholder="最大值" />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="有无合同" prop="iscontract">
          <el-select
            v-model="customerForm.iscontract"
            placeholder="选择有无合同"
            style="width: 100%"
          >
            <el-option label="有" :value="1" />
            <el-option label="无" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="账期" prop="isaccount">
          <el-select
            v-model="customerForm.isaccount"
            placeholder="选择账期"
            style="width: 100%"
          >
          <el-option label="日" :value="1" />
          <el-option label="周" :value="2" />
          <el-option label="月" :value="3" />
          <el-option label="半月" :value="4" />
          <el-option label="年结" :value="5" />
          </el-select>
        </el-form-item>
        <el-form-item label="开票税点" prop="taxpoint">
          <el-input
            v-model.number="customerForm.taxpoint"
            placeholder="输入开票税点"
            autocomplete="off"
          />
        </el-form-item>
        <!-- <el-form-item label="授权文件" prop="attachment">
          <el-upload
            ref="uploadRef"
            class="upload-demo"
            action="/api/upload/common"
            :auto-upload="true"
            :headers="headerUpload"
            :on-success="doUploadSuccess"
            name="picture"
          >
            <template #trigger>
              <el-button type="primary">选择文件</el-button>
            </template>
            <template #tip>
              <div class="el-upload__tip">
                
                <el-link v-if="customerForm.attachment" @click="doDownload" :underline="false" type="danger"><el-icon class="iconcolor" ><Download/></el-icon>下载</el-link>

              </div>
            </template>
          </el-upload>
        </el-form-item> -->
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="customerForm.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="2">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="common-drawer__footer">
        <el-button @click="doCustomerClose">关闭</el-button>
        <el-button type="danger" :loading="loading" @click="doCustomerSave">{{
          loading ? "提交中 ..." : "提交"
        }}</el-button>
      </div>
    </div>
  </el-drawer>
</template>
      
    <script setup>
import { ref, onMounted } from "vue";
// import { useRouter } from "vue-router";
import { ElDrawer, ElTable, ElMessage } from "element-plus";
import { listCustomer, saveCustomer,deleteCustomer } from "@/api/customer";
// import { download } from "@/api/common";
import storage from  "@/util/storage";

// import store from "@/store";
// import InputNumberRange from "@/components/common/InputNumberRange.vue";
// <InputNumberRange
//             :precision="num"
//             :disabled="false"
//             :value="maolivRange"
//             v-model="customerForm.maolivRange"
//             />

import util from "@/util/tool.js";

//文件下载
// const doDownload = ()=>{
//     download({fileName:customerForm.value.attachment}).then((res)=>{

//         let fileNameArr = (customerForm.value.attachment).split('.');
//         let fileName = customerForm.value.name+'-授权文件.'+fileNameArr[1];
//         const blob = new Blob([res.data]);
//         const elink = document.createElement('a');
//         elink.download = fileName;
//         elink.style.display = 'none';
//         elink.href = URL.createObjectURL(blob);
//         document.body.appendChild(elink);
//         elink.click();
//         URL.revokeObjectURL(elink.href);// 释放URL 对象
//         document.body.removeChild(elink);
//     })
// }

// const num = ref(2)
// const maolivRange = ref()
// const maolivRangeValue = ref([])

//const router = useRouter();
// let open = (routeName, row) => {
//   storage.saveSessionObject("customerPath",queryParam.value)
//   router.push({
//     name: routeName,
//     params: { id: row.customerid },
//     // query: { name: row.name },
//   });
// };

let timer;

let dialog = ref(false);
const loading = ref(false);
const loadingData = ref(true);


const drawerRef = ref(ElDrawer);

const customerFormRef = ref();

const total = ref(0);
const pageSize = ref(20); //每页显示条数

let title = ref("添加客户");

// const doUploadSuccess = (response) => {
//   customerForm.value.attachment = response.url;
// };

// const headerUpload = ref({
//   Authorization: store.state.user.token,
// });

//搜索查询
const queryParam = ref({
  pageNo: 1,
  pageSize: pageSize.value,
  name: "",
  paidaccount: "",
  balanceway: "",
  iscontract: "",
  isaccount: "",
  customertype: "",
  taxpoint: "",
  status: "",
});

const resetSearch = () => {
  queryParam.value = {
    pageNo: 1,
    pageSize: pageSize.value,
    name: "",
    paidaccount: "",
    balanceway: "",
    iscontract: "",
    isaccount: "",
    customertype: "",
    taxpoint: "",
    status: "",
  };
  getListCustomer();
};

const customerForm = ref({
  customerid: null,
  customertype: "",
  name: "",
  balanceway: "",
  iscontract: "",
  isaccount: "",
  paidway: "",
  paidaccount: "",
  maoliv: "",
  maolivge: "",
  attachment: "",
  taxpoint: null,
  status: 1,
});

const tableData = ref([]);

//onMounted方法
onMounted(() => {
  let query = storage.getSessionObject("customerPath")
  if (query) {
    queryParam.value = query
  }
  getListCustomer();
});

const doCustomerAdd = () => {
  title.value = "新增客户";
  resetForm();
};

const doCustomerEdit = (index, obj) => {
  title.value = "编辑客户";
  // customerForm.value = obj;//直接赋值会出问题

  customerForm.value = {
    customerid: obj.customerid,
    customertype: obj.customertype,
    name: obj.name,
    balanceway: obj.balanceway,
    iscontract: obj.iscontract,
    isaccount: obj.isaccount,
    paidway: obj.paidway,
    paidaccount: obj.paidaccount,
    maoliv: obj.maoliv,
    maolivge: obj.maolivge,
    attachment: obj.attachment,
    taxpoint: obj.taxpoint,
    status: obj.status,
  };
};

const doCustomerClose = () => {
  loading.value = false;
  dialog.value = false;
  clearTimeout(timer);
  customerFormRef.value.resetFields()
};

const resetForm = () => {
  customerForm.value = {
    customerid: null,
    customertype:"",
    name: "",
    balanceway: "",
    iscontract: "",
    isaccount: "",
    paidway: "",
    paidaccount: "",
    maoliv: "",
    maolivge: "",
    attachment: "",
    taxpoint: null,
    status: 1,
  };
};

const doCustomerSave = () => {
  customerFormRef.value.validate((valid) => {
    if (!valid) {
      //ElMessage("请先完善表单数据填写！");
      return;
    }

    saveCustomer(customerForm.value).then((res) => {
      loading.value = true;
      timer = setTimeout(() => {
        // 动画关闭需要一定的时间
        setTimeout(() => {
          loading.value = false;
        }, 400);
        if (res.data.code === 1) {
          getListCustomer();
          doCustomerClose();
        } else {
          ElMessage.error(res.data.msg);
        }
      }, 1000);
    });
  });
};

//更新用户状态
const doCustomerStatus = (index, obj) => {
  let status = obj.status == 1 ? 2 : 1;
  let data = { status, name: obj.name, customerid: obj.customerid.toString() };
  tableData.value[index].status = status;
  saveCustomer(data);
};


const doCustomerDelete = (index, obj) => {
  deleteCustomer(obj).then((res) => {
    if (res.data.code === 1) {
      getListCustomer();
    } else {
      ElMessage.error(res.data.msg);
    }
  });
};
//分页
const changePage = (current) => {
  queryParam.value.pageNo = current;
  getListCustomer();
};
const changeChangeSize = (size) => {
  pageSize.value = size;
  queryParam.value.pageSize = size;
  getListCustomer();
};

//客户表API
const getListCustomer = () => {
  storage.remove('customerPath')
  listCustomer(queryParam.value).then((res) => {
    total.value = res.data.extend.pages.total;
    queryParam.value.pageSize = pageSize.value;
    tableData.value = res.data.extend.pages.list;
    loadingData.value = false;
  });
};

///^d*(?:.d{0,2})?$/
const validateMaoliv = (rule, value, callback) => {
  //   const reg = /^d*(?:.d{0,2})?$/;
  const reg = /^(\d+\.?)?\d{0,2}$/;
  if (!String(value).match(reg)) {
    callback(new Error("只能填写整数、小数须保留两位小数"));
  } else {
    callback();
  }
};
const validateMaolivge = (rule, value, callback) => {
  if (value === "") {
    callback(new Error("请填写毛利率"));
  } else if (value < customerForm.value.maoliv) {
    callback(new Error("不能小于最小值"));
  } else {
    callback();
  }
};


//表单验证规则
const rules = ref({
  customertype: [
    {
      required: true,
      message: "请选择客户类型",
      trigger: "change",
    },
  ],
  name: [
    {
      required: true,
      message: "请输入名称",
      trigger: "blur",
    },
    {
      min: 2,
      max: 100,
      message: "名称长度2到100",
      trigger: "blur",
    },
  ],
  // balanceway: [
  //   {
  //     required: true,
  //     message: "请选择结算方式",
  //     trigger: "change",
  //   },
  // ],
  paidway: [
    {
      required: true,
      message: "请选择收款方式",
      trigger: "change",
    },
  ],
  paidaccount: [
    {
      required: true,
      message: "请填写收款账户",
      trigger: "blur",
    },
    {
      min: 2,
      max: 100,
      message: "账号长度2到100",
      trigger: "blur",
    },
  ],
  iscontract: [
    {
      required: true,
      message: "请选择有无合同",
      trigger: "change",
    },
  ],
  isaccount: [
    {
      required: true,
      message: "请选择账期",
      trigger: "change",
    },
  ],
  // taxpoint: [
  //   {
  //     required: true,
  //     // type: "number",
  //     message: "请填写开票税点",
  //     trigger: "blur",
  //   },
  // ],
  maoliv: [
    {
      required: true,
      message: "请填写最小毛利率",
      trigger: "blur",
    },
    { required: true, validator: validateMaoliv, trigger: "blur" },
  ],
  maolivge: [
    {
      required: true,
      message: "请填写最大毛利率",
      trigger: "blur",
    },
    { required: true, validator: validateMaolivge, trigger: "blur" },
  ],
});
</script>